import { postPublic } from './APIHelper';

export const submitSupportRequest = async payload => {
  return postPublic('support', payload);
};